import { useProjectStore } from '@/stores';
import { useUIStore } from '@/stores';
import { useOnboardingStore } from '@/stores/useOnboardingStore';

/**
 * useOnboarding — step detection + markOnboardingDone action.
 *
 * Step state reads from existing stores (ephemeral, no new persistence):
 *   Step 1: rooms.length > 0          ← useProjectStore
 *   Step 2: any room has items > 0    ← useProjectStore
 *   Step 3: hasExported               ← useUIStore (non-persisted, set at export sites)
 *
 * markOnboardingDone: sets local persist flag immediately + fire-and-forget POST.
 */
export function useOnboarding() {
  const rooms = useProjectStore((s) => s.rooms);
  const hasCreatedRoom = rooms.length > 0;
  const hasAddedService = rooms.some((r) => r.items.length > 0);
  const hasExported = useUIStore((s) => s.hasExported);
  const { onboardingDone, markDone } = useOnboardingStore();

  const completedCount = [hasCreatedRoom, hasAddedService, hasExported].filter(Boolean).length;

  const markOnboardingDone = () => {
    markDone();
    void fetch('/api/onboarding/complete', { method: 'POST' }).catch(() => {});
  };

  return {
    hasCreatedRoom,
    hasAddedService,
    hasExported,
    completedCount,
    onboardingDone,
    markOnboardingDone,
  };
}
